import { Box, CheckIcon, CloseIcon, Typography } from '@cmg/design-system';

export function XcEmailReadRow({
  label,
  description,
  isEnabled,
}: Readonly<{
  label: string;
  description: string;
  isEnabled: boolean;
}>) {
  return (
    <Box display="flex" alignItems="flex-start">
      <Box pr={1}>{isEnabled ? <CheckIcon color="success" /> : <CloseIcon color="error" />}</Box>
      <Box>
        <Typography variant="body2">{label}</Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </Box>
    </Box>
  );
}
